import http from "@services/httpService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type { IIntegrationResult, IIntegrationResultFilter } from "@models/integrationResult/integrationResultModel"

class IntegrationResultService {
  public async getAll(
    params: IIntegrationResultFilter
  ): Promise<PagedResultDto<IIntegrationResult>> {
    const res = await http.get(
      "api/services/app/IntegrationResult/GetAll",
      {
        params,
      }
    )
    return res.data.result
  }

  public async getDetail(id: number): Promise<IIntegrationResult> {
    const res = await http.get(
      "api/services/app/IntegrationResult/GetDetail",
      {
        params: { id },
      }
    )
    return res.data.result
  }
}

export default new IntegrationResultService()
